import { addDays, addMonths, subDays } from "date-fns";
import { ChevronLeft, ChevronRight } from "lucide-react";

import { useTempBookingStore } from "~/stores/use-booking-store";
import { Button } from "../ui/button";
import { BookingDatePicker } from "./booking-date-picker";

interface LayoutCalendarProps {
  onSelect?: (date: Date) => void;
}

export default function LayoutCalendar({ onSelect }: LayoutCalendarProps) {
  const { selectedDate, setSelectedDate } = useTempBookingStore();
  const today = new Date();

  const handleSelect = (date: Date) => {
    console.log(date);
    setSelectedDate(date);
    onSelect?.(date);
  };
  return (
    <div className="flex flex-col border-l overflow-hidden h-full z-[1000]">
      <div className="flex flex-row gap-2 w-full p-2 shadow-lg">
        <Button
          variant="outline"
          onClick={() => setSelectedDate(subDays(selectedDate, 1))}
        >
          <ChevronLeft />
        </Button>
        <Button
          onClick={() => {
            setSelectedDate(today);
          }}
          className="flex-grow"
          variant="outline"
        >
          Today
        </Button>
        <Button
          variant="outline"
          onClick={() => setSelectedDate(addDays(selectedDate, 1))}
        >
          <ChevronRight />
        </Button>
      </div>
      <div className="flex flex-col gap-2 overflow-auto small-scrollbar">
        <BookingDatePicker
          showOutsideDays={false}
          onSelect={handleSelect}
          selected={selectedDate}
          disableNavigation={true}
          month={today}
        />
        <BookingDatePicker
          showOutsideDays={false}
          onSelect={handleSelect}
          selected={selectedDate}
          disableNavigation={true}
          month={addMonths(today, 1)}
        />
        <BookingDatePicker
          showOutsideDays={false}
          onSelect={handleSelect}
          selected={selectedDate}
          disableNavigation={true}
          month={addMonths(today, 2)}
        />
      </div>
    </div>
  );
}
